module.exports = __webpack_public_path__ + "img/down-arrow.f4a8b59f.svg";